import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'dgx-ui-wl-header-powered-by',
  templateUrl: './header-powered-by.component.html',
  styleUrls: ['./header-powered-by.component.scss'],
})
export class HeaderPoweredByComponent {
  /**
   * Emits a click event back to the parent component
   */
  @Output() clicked: EventEmitter<MouseEvent> = new EventEmitter();

  /**
   * Tracks menu open state
   */
  isOpen = false;
  @Input() linkUrl: string | null = 'https://www.domesticandgeneral.com/';

  /**
   * Listens and fires emit `clicked` when clicked
   */
  onClick(e: MouseEvent) {
    this.clicked.emit(e);
    this.isOpen = false;
  }
}
